
export enum RESOURCE_TYPES {
    ORE = 1,
    TIMBER,
  }

export type Resource = {
    ResourceType: RESOURCE_TYPES;
    ResourceCount: number;
};

